var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"select",class:{
    select_compact: _vm.compact,
    select_error: _vm.error
  },attrs:{"placeholder":_vm.placeholder,"options":_vm.options,"reduce":(item) => item.value,"value":_vm.value,"clearable":_vm.clearable ?? true,"searchable":_vm.inputMode,"taggable":_vm.inputMode},on:{"input":_vm.onInput,"option:selected":_vm.onOptionSelected,"search":_vm.onSearch,"close":_vm.onClose}})
}
var staticRenderFns = []

export { render, staticRenderFns }